<form class="g-3 needs-validation" novalidate [formGroup]="frmFields" (ngSubmit)="onSubmit(content,referral)">
    <div class="row" *ngIf="premiums">
        <div class="col-md-8">
            <h4>Quote Summary</h4>
            <div class="form_sections" style="min-height: 411px;">
                <div class="row">
                    <div class="col-md-5 fw-300">Compulsory Excess</div>
                    <div class="col-md-7 fw-500">&pound;{{ premiums.compulsory_excess }}</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5 fw-300">Voluntary Excess</div>
                    <div class="col-md-7">
                        <mat-form-field class="w-100" *ngIf="staticData">
                            <mat-label>Voluntary Excess</mat-label>
                            <mat-select formControlName="voluntary_excess" class="form-control form-control-sm"
                                name="voluntary_excess" required (selectionChange)="calculatePremium()"
                                [ngClass]="{ 'is-invalid': (f.voluntary_excess.touched || submitted) && f.voluntary_excess.errors?.required }">
                                <mat-option [value]="v" *ngFor="let v of staticData.voluntary_excess_options">&pound;{{ v }}</mat-option>
                            </mat-select>
                            <div class="invalid-feedback" *ngIf="(f.voluntary_excess.touched || submitted) && f.voluntary_excess.errors?.required">Please select an option.</div>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <span class="fw-500">Young & inexperienced driver excess</span> (does not apply to Agricultural vehicles)
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5">Where driver is aged 21 years or below</div>
                    <div class="col-md-7">&pound;250</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5">Where driver is aged 22-24 years</div>
                    <div class="col-md-7">&pound;250</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5">Where a driver aged 25 years or more has not held their full relevant UK/EU driving license at least 12 months</div>
                    <div class="col-md-7">&pound;250</div>
                </div>
            </div>

            <div class="row" *ngIf="!isBroker">
                <div class="col-md-12 mb-3">
                    <label>Refer Reason</label>
                    <textarea name="refer_reason" class="form-control" formControlName="refer_reason" required
                    (change)="onReferReasonChange($event)"
                    [ngClass]="{ 'is-invalid': (f.refer_reason.touched || submitted) && f.refer_reason.errors?.required }"></textarea>
                    <div class="invalid-feedback" *ngIf="(f.refer_reason.touched || submitted) && f.refer_reason.errors?.required">Please enter some notes.</div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6 text-right">
                    <button type="submit" class="btn btn-success btn-sm" [disabled]="isSaving || hasErrors" (click)="setReferAndExit(false)">
                        <span *ngIf="isSaving" class="spinner-border spinner-border-sm mr-1"></span>{{btn_text}}
                    </button>
                    <button type="submit" class="btn btn-success btn-sm ml-2" *ngIf="!isBroker" [disabled]="isSaving || hasErrors" (click)="setReferAndExit(true)">Refer and Exit</button>
                    <div class="invalid-feedback d-block" *ngIf="hasErrors">
                        The quote cannot be saved until the errors listed under &quot;Attention Required&quot; are resolved.
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="calculator mt-4" style="position: relative;width: 100%;top: 0;right: 0;">
                <mat-accordion>
                    <mat-expansion-panel expanded>
                        <mat-expansion-panel-header class="m-0">
                            <mat-panel-title class="cal_header m-0">Premium</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="cal_body p-3 bg-white">
                            <p><b>Vehicle Insurance (exc IPT):</b><br>&pound;{{ (premiums?gross_premium - (premiums.ipt):0) | number:'1.2-2' }}</p>
                            <p><b>Vehicle IPT</b><br>&pound;{{premiums.ipt | number:'1.2-2'}}</p>
                            <p><b>Total Premium inc IPT</b><br>&pound;{{ total_prem_inc_ipt | number:'1.2-2' }}</p>
                            <p><b>Peliwica Fee</b><br>&pound;{{peliwica_fee}}</p>
                            <div class="mb-2" *ngIf="modelObj.is_send_email == 1">
                                <b>Broker Fee</b><br>
                                <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text dark-green-bg text-white">&pound;</span></div>
                                    <input type="number" class="form-control form-control-sm" required name="broker_admin_fee" formControlName="broker_admin_fee"
                                        (change)="onBrokerCommissionChange($event)" [readonly]="isBroker"
                                        [ngClass]="{ 'is-invalid': (f.broker_admin_fee.touched || submitted) && f.broker_admin_fee.errors?.required }">
                                    <div class="invalid-feedback" *ngIf="(f.broker_admin_fee.touched || submitted) && f.broker_admin_fee.errors?.required">Broker commission is required.</div>
                                </div>
                            </div>
                            <p><b>Total (inc IPT & Fee)</b><br>&pound;{{total_amount | number:'1.2-2'}}</p>
                            <p *ngIf="vehiclePremiumRows.length > 0"><b><u>Rate per Vehicle</u></b></p>
                            <div class="row" *ngFor="let vp of vehiclePremiumRows">
                                <div class="col-6"><b>{{ vp.reg }}</b></div>
                                <div class="col-6">&pound;{{ vp.premium | number:'1.2-2' }}</div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-12" *ngIf="!isBroker">
                                    <b>Commission</b><br>
                                    <div class="input-group">
                                        <div class="input-group-prepend"><span class="input-group-text dark-green-bg text-white">%</span></div>
                                        <input type="number" class="form-control form-control-sm" placeholder="Max available" name="commission" formControlName="commission" min="0" [attr.max]="modelObj && modelObj.broker_commission ? modelObj.broker_commission : 20"
                                            (change)="onCommissionChange($event)"
                                            [ngClass]="{ 'is-invalid': (f.commission.touched || submitted) && f.commission.errors?.required }">
                                        <div class="invalid-feedback" *ngIf="(f.commission.touched || submitted) && f.commission.errors?.required">Commission is required.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <div class="form_sections mt-3">
                <h4>Quote Summary</h4>
                <hr>
                <div class="row" *ngIf="calErrors && calErrors.length > 0 && attention_required_text == ''">
                    <div class="col-md-12">
                        <div class="alert alert-danger">
                            <h4>Attention Required</h4>
                            <ul><li *ngFor="let e of calErrors">{{ (e.detail)?e.detail:e.title }}</li></ul>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="attention_required_text != ''">
                    <div class="col-md-12">
                        <div class="alert alert-danger">
                            <h4>Attention Required</h4>
                            <ul><li>{{attention_required_text}}</li></ul>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5 fw-300">Countrywise</div>
                    <div class="col-md-7 fw-500">Agricultural Vehicle</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5 fw-300">Reference</div>
                    <div class="col-md-7 fw-500">{{ reference }}</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5 fw-300">Cover Dates</div>
                    <div class="col-md-7 fw-500">{{ cover_period }}</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5 fw-300">Customer Type</div>
                    <div class="col-md-7 fw-500 text-capitalize">{{ proposer_type }}</div>
                </div>
            </div>
        </div>
    </div>
</form>
<ng-template #content let-modal>
    <div class="modal-body"><div class="helptext" [innerHTML]="helptext"></div></div>
    <div class="modal-footer"><button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button></div>
</ng-template>
<ng-template #referral let-modal>
    <div class="modal-body">
        <div class="helptext">Clicking save will send your quote to the underwriter, the quote will then be locked for editing until the underwriter decision has been made.</div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-dark" (click)="modal.close()">Exit</button>
        <button type="button" class="btn btn-success" (click)="saveQuote(content)">Save</button>
    </div>
</ng-template>
